import React, { useState, useEffect, useRef } from 'react';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import Status from '@core/constants/task/TaskStatus.constants';
import useCreateMarkers from '@core/services/customHooks/useCreateMarkers';
import { mapConfig } from 'Utils/map/googleMaps.config';
import { setCenter, setZoom } from '@core/store/modules/map/mapSlice';
import { selectCenter, selectZoom, selectRoute } from '@core/store/modules/map/mapSelectors';
import { fitMapBounds } from '@core/utils/map/mapBounds';
import { convertGoogleLatLng } from '@core/utils/location/addressHandler.utils';
import Loading from '~/FielderElements/Loading/Loading';
import Route from '../../Map/components/Route';
import FielderMarker from '~/Map/components/FielderMarker';

const containerStyle = {
	width: '100%',
	height: '100%',
	borderRadius: '20px',
};
const MyOperationTaskMap = ({ tasks = [], onTaskClick = () => {}, onAgentClick = () => {}, lan }) => {
	console.log("MyOperationTaskMap - tasks: ", tasks);
	const dispatch = useDispatch();
	const mapZoom = useSelector(selectZoom);
	const mapCenter = useSelector(selectCenter);
	const route = useSelector(selectRoute);
	const [markerGroups, setMarkerGroups] = useState([]);      // ← para fitMapBounds
	const [renderMarkers, setRenderMarkers] = useState([]);
	const { isLoaded } = useJsApiLoader(mapConfig);
	const mapRef = useRef(null);
	const [googleMapInstance, setGoogleMapInstance] = useState(null);
	const [showMap, setShowMap] = useState(false);
	const markersInfo = {
		tasks,
		onTaskClick,
		onAgentClick,
		hideFinished: true,
		hideCancelled: true,
	};
	const { taskMarkers, agentMarkers } = useCreateMarkers(markersInfo);
	const [markers, setMarkers] = useState([]);
	// Update markers from grouped structure
	useEffect(() => {
		const groups = [];
		for (const status in taskMarkers) {
			const group = taskMarkers[status];
			if (group?.markers?.length > 0 && status !== Status.FINISH) groups.push(group);
		}
		if (agentMarkers?.markers?.length > 0) groups.push(agentMarkers);
		setMarkerGroups(groups);
		setRenderMarkers(groups.flatMap(g => g.markers));
	}, [taskMarkers, agentMarkers]);
	useEffect(() => {
		if (googleMapInstance && markerGroups.length > 0)
			fitMapBounds(googleMapInstance, markerGroups, [], null);
	}, [googleMapInstance, markerGroups]);
	// Fit map to markers
	useEffect(() => {
		if (googleMapInstance && markers.length > 0) fitMapBounds(googleMapInstance, markers, [], null);
	}, [googleMapInstance, markers]);
	// Trigger Google Maps resize
	useEffect(() => {
		if (googleMapInstance && typeof google !== 'undefined') {
			setTimeout(() => {
				google.maps.event.trigger(googleMapInstance, 'resize');
			}, 300);
		}
	}, [googleMapInstance]);
	// Delay map rendering
	useEffect(() => {
		if (isLoaded) {
			const timer = setTimeout(() => setShowMap(true), 300);
			return () => clearTimeout(timer);
		}
	}, [isLoaded]);
	// Center and Zoom Redux Sync (default or geo)
	useEffect(() => {
		if (googleMapInstance && markers.length > 0) {
			fitMapBounds(googleMapInstance, markers, [], null);
			const center = googleMapInstance.getCenter();
			if (center?.lat && center?.lng) {
				dispatch(setCenter(convertGoogleLatLng(center)));
				dispatch(setZoom(googleMapInstance.getZoom()));
			}
		}
	}, [googleMapInstance, markers, dispatch]);
	const handleOnLoad = (map) => {
		mapRef.current = map;
		setGoogleMapInstance(map);
		dispatch(setZoom(mapZoom));
	};
	if (!isLoaded || !showMap) {
		return (
			<Box
				sx={{
					width: '100%',
					height: 500,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					borderRadius: 2,
				}}
			>
				<Loading inline size={'32px'} sx={{ color: '#dc5c87' }} />
				<Typography sx={{ color: 'white', ml: 2 }}>{lan.loading}</Typography>
			</Box>
		);
	}
	return (
		<Box sx={{ width: '100%', maxWidth: '100vw', px: 2, py: 1 }}>
			<Box sx={{ width: '100%', height: 500, borderRadius: 2, overflow: 'hidden' }}>
				<GoogleMap
					mapContainerStyle={containerStyle}
					zoom={mapZoom}
					onLoad={handleOnLoad}
					ref={mapRef}
				>
					{renderMarkers.map((m, i) => (
						<FielderMarker key={i} marker={m} />
					))}
					{/*renderMarkers.map((m, i) => (
						<MarkerF
							key={i}
							position={m.position}
							icon={m.icon}
							title={m.title}
							onClick={m.onClick}
						/>
					))*/}
					{route && <Route />}
				</GoogleMap>
			</Box>
		</Box>
	);
};
export default React.memo(MyOperationTaskMap);
